<div class="container-fluid">
    <div class="row mb-3">
        <div class="col px-1">
            <ng-select name="cropDropdown" id="cropDropdown" width="100%"
                       [items]="crops"
                       [(ngModel)]="selectedCropName"
                       [placeholder]="'field-manager.study-instances-filter-select.placeholder.all' | translate"
                       [notFoundText]="'no.data' | translate"
                       [clearable]="false"
                       (change)="onCropChange()"
                       (clear)="onCropChange()">
            </ng-select>
        </div>
        <div class="col px-1">
            <ng-select name="programDropdown" id="programDropdown" width="100%"
                       *ngIf="crops?.length"
                       bindLabel="label"
                       bindValue="id"
                       [placeholder]="'field-manager.study-instances-filter-select.placeholder.all-programs' | translate"
                       [notFoundText]="'no.data' | translate"
                       [virtualScroll]="true"
                       [(ngModel)]="selectedProgramUUID"
                       [items]="programItems"
                       (open)="searchPrograms(select.searchTerm)"
                       (scrollToEnd)="fetchMorePrograms(select.searchTerm)"
                       (search)="onProgramSearch(select.searchTerm)"
                       (clear)="clearPrograms()"
                       (ngModelChange)="onProgramChange($event)"n
                       #select>
            </ng-select>
        </div>
        <div class="col px-1">
            <ng-select name="studiesDropdown" id="studiesDropdown" width="100%"
                       bindLabel="studyName"
                       [placeholder]="'field-manager.study-instances-filter-select.placeholder.all-studies' | translate"
                       [notFoundText]="'no.data' | translate"
                       [items]="studies"
                       [(ngModel)]="selectedStudy"
                       [clearable]="true"
                       (change)="onStudyChange()">
            </ng-select>
        </div>
<!--        <div class="col px-1">-->
<!--            <ng-select name="cropDropdown3" id="cropDropdown4" width="100%"></ng-select>-->
<!--        </div>-->
    </div>
</div>
